import * as React from "react";
import { ConfigurationAssetPage } from "./ConfigurationAssetPage";
import { ConfigurationAssetProvider } from "./context/ConfigurationAssetContext";

type Props = {};

const AssetPage = (props: Props) => {
	return (
		<ConfigurationAssetProvider>
			<ConfigurationAssetPage />
		</ConfigurationAssetProvider>
	);
};

export default AssetPage;
